<template>
  <div>
    <div class="block-content" v-if="!isOnSettingsMenu">
      <div
        class="mr-0 form-check form-check-inline"
      >
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="check-qna-moderation"
            v-model="$store.state.presentation.isModerationMode"
            @change="handleCheckBoxModeration"
          >
          <label
            class="custom-control-label"
            for="check-qna-moderation"
          >
            Moderate audience’s questions
          </label>
          <span class="pl-1 title-table-presentation-tooltip">
            <b-button
              v-tooltip="moderationToolTip"
              class="tooltip-btn"
            />
            <i class="fas fa-question-circle" />
          </span>
        </div>
        <QnAModerationLink v-if="$store.state.presentation.isModerationMode" />
      </div>
    </div>
    <!-- Moderation on Header Settings -->
    <div
      v-if="isOnSettingsMenu"
      class="mb-3 settings-moderation-wrapper"
    >
      <aha-checkbox
        id="settings-check-qna-moderation"
        v-model="$store.state.presentation.isModerationMode"
        @change="handleCheckBoxModeration"
      >
        <span>Moderate audience’s questions
          <aha-icon
            class="ml-1 text-base-70"
            name="question"
            viewBox="0 0 24 24"
            width="15"
            height="15"
            v-tooltip="moderationToolTip"
          />
        </span>
      </aha-checkbox>
      <QnAModerationLink v-if="$store.state.presentation.isModerationMode" />
    </div>
    <!-- End of Moderation on Header Settings -->
  </div>
</template>

<script>
import QnAModerationLink from '@/components/presentations/QnAModerationLink.vue'
import QnAModerationLinkContainer from '@/containers/qna-moderation/QnAModerationLink'

export default {
  components: {
    QnAModerationLink: QnAModerationLinkContainer(QnAModerationLink),
  },
  props: {
    isOnSettingsMenu: {
      type: Boolean,
      default: false,
    },
    handleCheckBoxModeration: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      moderationToolTip: "Use the link provided to approve and dismiss questions before they are shown on the presenter's screen",
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss-v2/variables.scss';

.settings-moderation-wrapper.disabled {
  color: $disabled-text;
  @apply italic;
  ::v-deep .checkbox-component-wrapper {
    background-color: $disabled-input;
  }
}
</style>
